<template>
    <div>
    
        <div class="grid-container">
            <div class="top-half"></div>
            <div class="bottom-half">
                <div class="card-container">
                    <CCard class="border-radius-16px p-4 mb-5">
                        <div class="text-center">
                            <h3 class="custom-40px-700 text-center font-color-064BB4"><img src="../assets/img/status-up-blue.png" style="max-width:48px" class="mr-2" />MyHR Solutions</h3>
                            <div class="text-left">
                                <!-- <img src="../assets/img/arrowback.png" style="max-width:20px" class="text-left" @click="GoBack()" /> -->
                                <h4 class="custom-36px-700 font-color-171717 text-left mt-5">Email Verification</h4>
                                <p class="custom-16px-400 text-left">Please confirm your email address by clicking the Verify Email button on following below. This step essential to complete your registration and ensure the security of your account.</p>
                            </div>
    
                        </div>
    
                        <div v-if="ErrorLogin" class="ml-4 mr-4 mt-4">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <div class="text-center mt-3 mb-4">
                            <CButton class="bg-0B63F6 p-2 text-center text-white pr-5 pl-5 border-radius-half" @click="submitVerification" block>{{ lblButton }}</CButton>
                        </div>
    
                    </CCard>
                </div>
            </div>
        </div>
    
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            code: ["", "", "", ""],
            lblButton: "Verify Email",
            verificationCode: null,  // Holds the verification code from the URL
            ErrorLogin: false,
            Message: ""
        };
    },

    mounted() {
        // Extract verification code when the component is mounted
        const urlParams = new URLSearchParams(window.location.search);
        this.verificationCode = urlParams.get('code');

        if (!this.verificationCode) {
            this.ErrorLogin = true;
            this.Message = "Invalid or missing verification code.";
        }
    },


    methods: {
        // submitVerification() {
        //     this.verificationCode = this.code.join(""); // Concatenate the digits
        //     console.log("Verification Code:", this.verificationCode);
        //     this.ValidateCode(this.verificationCode);
        // },
        ValidateCode(verificationCode) {
            this.lblButton = "Processing";

            const formData = new FormData();

            formData.append("userEmail", this.$route.query.email);
            formData.append("code", verificationCode);

            return this.$API
                .post(this.$ValidateForgotPasswordCode, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {

                        this.$router.push("ResetPassword?email=" + this.$route.query.email + "&code=" + verificationCode);
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },
        submitVerification() {
            this.lblButton = "Processing";
            this.ErrorLogin = false;

            if (!this.verificationCode) {
                this.ErrorLogin = true;
                this.Message = "No verification code found.";
                return;
            }

            // Send the verification code to the backend API
            this.$API
                .get(this.$ValidateEmail + "/" + this.verificationCode)
                .then((response) => {
                    if (response.status === 200 && response.data === "Ok") {
                        this.$dialog
                        .alert(
                            "You have successfully verify your email")
                        .then(function () {});
                        this.lblButton = "Verified";
                        this.$router.push("/Login");
                    } else if (response.data === "Expired Code.") {
                        this.Message = "The verification code has expired. Please request a new one.";
                        this.lblButton = "Resend Verification";
                    } else if (response.data === "Already verified.") {
                        this.Message = "Your email is already verified.";
                        this.lblButton = "Verified";
                    } else {
                        this.Message = response.data || "An error occurred.";
                        this.lblButton = "Try Again";
                        this.ErrorLogin = true;
                    }
                })
                .catch((error) => {
                    this.ErrorLogin = true;
                    this.Message = error.response?.data?.message || "An error occurred during verification.";
                    this.lblButton = "Try Again";
                });
        },
        GoBack() {
            this.$router.push("ForgotPassword");
        }



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>